module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_2.a0f7df28.png";